class ApplicationInfo extends HTMLElement {
  constructor() {
    super();
    const anchor = this.querySelectorAll('a');
    anchor.forEach((ele) => {
      ele.addEventListener('click', (e) => {
        e.preventDefault();
        const hreflink = e.target.href;
        window.open(`${hreflink}`, '_blank');
      });
    });
  }
}
customElements.define('application-info', ApplicationInfo);
